module.exports = __webpack_public_path__ + "static/media/0360_Medium.3df66cc7.jpg";